<template>
  <section class="lucky-draw-wrapper flex-col-center">
    <div
      class="lucky-grid-wrapper"
      :style="{ backgroundImage: `url(${raffleBgImage})` }"
    >
      <LuckyGrid
        class="lucky-canvas"
        ref="LuckDraw"
        :prizes="rafflePrizeList"
        :blocks="blocks"
        :buttons="buttons"
        :default-style="defaultStyle"
        :active-style="activeStyle"
        @end="endCallBack"
      />
    </div>
    <BtnGroup
      :page="page"
      :isOver="isOver"
      :isLogin="isLogin"
      :loading="loading"
      :inPopup="inPopup"
      :remainingShots="remainingShots"
      :upperLimitCount="upperLimitCount"
      :extraInfo="extraInfo"
      @clickHandler="btnClickHandler"
    />
    <div class="entry-wrapper">
      <ActivityRules
        :page="page"
        :inPopup="inPopup"
        :rulesText="rulesText"
        :ruleBgColor="ruleBgColor"
      />
      <p @click="goCheckMyPrize" v-if="isLogin">
        {{ $t('luckyDraw.award_desc.prize_record') }}
      </p>
    </div>
    <CountdownTimer
      :inPopup="inPopup"
      :startTimestamp="startTimestamp"
      :endTimestamp="endTimestamp"
      :currTimestamp="currTimestamp"
      @onActivityIsOver="onActivityIsOver"
      :countDownColor="countDownColor"
    />
    <RaffleResultPopup
      :page="page"
      :activityId="activityId"
      :showResult="showResult"
      :text="raffleResDesc"
      @closePopup="closePopup"
      :inPopup="inPopup"
      :bgColor="winPopColor"
      :btnColor="winButtonColor"
    />
  </section>
</template>

<script>
  import LuckyGrid from 'vue-luck-draw'
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import dayjs from 'dayjs'
  import { Toast } from 'vant'
  import {
    queryRemainingShots,
    queryLuckyDrawResult,
  } from '@/api/activity/luckyDraw'
  import { getCouponList } from '@/api/fission'
  import ActivityRules from './components/ActivityRules'
  import RaffleResultPopup from './RaffleResultPopup'
  import { textFormat } from '@/utils/pluralRules'
  import { priceFormat } from '@/utils/priceFormat'
  import { getSecondLevelTimestamp } from '@/utils/timeFormat'
  import { imgLoadedHandler } from '@/utils/image.js'
  import {
    trackGainShots,
    trackClickTryOne,
    trackClickTryTen,
    trackViewPrize,
  } from '@/pages/Activity/firebase'
  // import { prizesMockList } from './mockData'
  import CountdownTimer from './components/countdownTimer'
  import BtnGroup from './components/btnGroup'

  Vue.use(LuckyGrid)
  Vue.use(Toast)

  export default {
    name: 'lucky-grid',
    components: {
      BtnGroup,
      ActivityRules,
      RaffleResultPopup,
      CountdownTimer,
    },
    props: {
      page: {
        type: String,
        default: '',
      },
      inPopup: {
        type: Boolean,
        default: false,
      },
      configData: {
        type: Object,
        default: () => {},
      },
      isLogin: {
        type: Boolean,
        default: false,
      },
      activityOffline: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        blocks: [
          {
            padding: '10px',
            background: 'rgba(0, 0, 0, 0)',
            borderRadius: '10px',
          },
        ],
        /* 中间格子 */
        buttons: [
          {
            x: 1,
            y: 1,
            background: 'transparent',
            fonts: [
              {
                text: ``,
                top: '20%',
                fontSize: this.inPopup ? '12px' : '14px',
                lineHeight: '14px',
                fontStyle: 'Noto Sans',
                fontWeight: 500,
                wordWrap: true,
                lengthLimit: '88%',
              },
            ],
            imgs: [
              {
                src: require('@/assets/images/activities/luckydraw/lucky-grid-center.png'),
                width: '100%',
                height: '100%',
                top: '0',
              },
            ],
          },
        ],
        /* 格子默认样式 */
        defaultStyle: {
          fontColor: '#fff',
          fontSize: '10px',
          lineHeight: '13px',
          wordWrap: false,
        },
        activeStyle: {
          fontColor: '#fff',
          background: 'transparent',
        },
        raffleNum: 1, // 点击单次抽奖或十连抽
        raffleResult: [],
        raffleError: false,
        resultDesc: '',
        currTimestamp: Math.floor(new Date().getTime() / 1000), // 秒级时间戳，与接口返回保持一致
        remainingShots: '', // 剩余抽奖机会，注意不要写成0，以便能 watch 到变化
        upperLimitCount: 0, // 剩余最大可抽奖次数
        raffleResDesc: '',
        showResult: false,
        loading: false,
        couponDetails: {}, // 保存优惠券详情数据，其 key 形如：3__couponId，3代表优惠券类型
        raffleBgImage: '', // 抽奖转盘外框图
      }
    },
    computed: {
      ...mapState(['region', 'gameName', 'userInfo']),
      startTimestamp() {
        // 秒级时间戳
        return getSecondLevelTimestamp(this.configData?.startTime || 0)
      },
      endTimestamp() {
        // 秒级时间戳
        return getSecondLevelTimestamp(this.configData?.endTime || 0)
      },
      isOver() {
        if (this.activityOffline || this.endTimestamp === 0) {
          return true
        } else {
          return dayjs(this.currTimestamp * 1000).isAfter(
            this.endTimestamp * 1000
          )
        }
      },
      timeToRequst() {
        return !!(this.isLogin && this.activityId)
      },
      extraInfo() {
        return this.configData?.extraInfo || {}
      },
      game() {
        return this.configData?.game || ''
      },
      activityId() {
        return this.configData?.activityId
      },
      rulesText() {
        return this.extraInfo?.rule || ''
      },
      ruleBgColor() {
        return this.extraInfo?.ruleBackgroundColor || '#6c3cf8'
      },
      countDownColor() {
        return (
          this.extraInfo?.countDownColor ||
          'linear-gradient(180deg, #643DD4 0%, #4922B2 100%)'
        )
      },
      winPopColor() {
        return this.extraInfo?.winPopColor || '#6C3CF8'
      },
      winButtonColor() {
        return this.extraInfo?.winButtonColor || '#FEED00'
      },
      btnDesc() {
        return this.getBtnDesc()
      },
      rafflePrizeList() {
        const { drawTurntableList = [] } = this.extraInfo
        let prizes = []
        const axis = [
          [0, 0],
          [1, 0],
          [2, 0],
          [2, 1],
          [2, 2],
          [1, 2],
          [0, 2],
          [0, 1],
        ]
        if (drawTurntableList.length < 1) {
          axis.forEach((item) => {
            prizes.push({
              x: item[0],
              y: item[1],
              title: '',
              fonts: [{ text: '', top: '60%' }],
              imgs: [
                {
                  src: require('@/assets/images/activities/luckydraw/lucky-grid-center.png'), // 奖品图的垫底默认背景图
                  width: '94%',
                  height: '94%',
                  top: '3%',
                },
              ],
            })
          })
        } else {
          // 按照所给 location 升序排列
          const sortedArray = drawTurntableList.sort(
            (a, b) => a.location - b.location
          )
          sortedArray.forEach((item, index) => {
            prizes.push({
              x: axis[index][0],
              y: axis[index][1],
              title: '',
              fonts: [{ text: '', top: '60%' }],
              imgs: [
                {
                  src: item.turntablePic,
                  activeSrc: item.winPic, // 当中奖标记处于当前格子时，将替换显示图片
                  width: '94%',
                  top: '3%',
                },
              ],
            })
          })
        }
        return prizes
      },
      rafflePrizePosition() {
        const { drawTurntableList = [] } = this.extraInfo
        let res = new Map()
        drawTurntableList.forEach((item) => {
          //awardType 奖品类型：-1谢谢惠顾 3优惠券 4商品 5 KGold
          //awardContent 奖品内容: 如果是谢谢惠顾，则为"thanks",为优惠券则为优惠券id,如果为商品/KGold 则为赠送的数量
          const { awardType, awardContent, location } = item
          const prizeKey = `${awardType}__${
            awardType * 1 === -1 ? 'thanks' : awardContent
          }`
          if (res.has(prizeKey)) {
            let temp = res.get(prizeKey)
            temp.push(location - 1)
            res.set(prizeKey, temp)
          } else {
            res.set(prizeKey, [location - 1]) // 索引从0开始，因此比次序小1
          }
        })
        return res
      },
      couponPrizes() {
        // 返回一个对象，配置奖品为优惠券, key 为 '3__couponId'，value 为 couponId
        const { drawTurntableList = [] } = this.extraInfo
        const res = {}
        drawTurntableList.forEach((item) => {
          const { awardType, awardContent } = item
          if (awardType * 1 === 3) {
            res[`${awardType}__${awardContent}`] = awardContent
          }
        })
        if (Object.keys(res).length > 0) {
          // 标记是否有数据
          res.hasData = true
        }
        return res
      },
    },
    watch: {
      activityId(val) {
        const { defaultBackgroundPic, drawTurntablePic } = this.extraInfo
        imgLoadedHandler(
          drawTurntablePic,
          require('@/assets/images/activities/luckydraw/lucky-draw-container.png')
        ).then((res) => {
          this.raffleBgImage = res
        })
        imgLoadedHandler(
          defaultBackgroundPic,
          require('@/assets/images/activities/luckydraw/lucky-grid-center.png')
        ).then((res) => {
          this.buttons[0].imgs[0].src = res
        })
        if (!val) {
          this.$router_push({
            path: '/',
          })
        }
      },
      timeToRequst(val) {
        val && this.getRemainingShots()
      },
      btnDesc(val) {
        let str = val.trim()
        this.buttons[0].fonts[0].text = str
        const target = this.buttons[0].fonts[0]
        // 以下代码是为了确保文案看起来是在格子中间
        // 设置的比例是根据一行能容纳的字符串的长度来调的（和 fontSize与 lengthLimit 有关 ）
        target.top = this.getTopRatio(str)
        target.fontSize = this.inPopup ? '12px' : '14px'
        target.lineHeight = this.inPopup ? '13px' : '16px'
      },
      'couponPrizes.hasData'(value) {
        if (!value) {
          return
        }
        let couponIdString = ''
        for (let val of Object.values(this.couponPrizes)) {
          if (val !== true) {
            couponIdString += val + ','
          }
        }
        if (couponIdString) {
          // 一次性请求所配置的优惠券奖品信息
          this.getCouponInfos(couponIdString).then((couponInfoList) => {
            const temp = {}
            couponInfoList.forEach((item) => {
              temp[`3__${item.id}`] = item
            })
            this.couponDetails = temp
          })
        }
      },
    },
    async mounted() {
      this.timeToRequst && this.getRemainingShots()
      this.buttons[0].fonts[0].text = this.getBtnDesc()
    },
    methods: {
      onActivityIsOver() {
        this.$emit('onActivityIsOver', true)
      },
      getTopRatio(val) {
        const oneLineCharsNum = this.inPopup ? 9 : 12, // 一行能放下的字符数（试了各种多语言文案数出来的）
          topForPopup = ['36%', '27%', '22%', '15%'], // 分别对应n(从1开始)行数据的top值
          topForPage = ['38%', '27%', '20%', '18%'],
          topList = this.inPopup ? topForPopup : topForPage
        let topRatio
        if (val.length > oneLineCharsNum * 3) {
          // 文案占据四行
          topRatio = topList[3]
        } else if (val.length > oneLineCharsNum * 2) {
          // 文案占据三行
          topRatio = topList[2]
        } else if (val.length > oneLineCharsNum) {
          // 文案占据两行
          topRatio = topList[1]
        } else {
          // 文案占据两行
          topRatio = topList[0]
        }
        return topRatio
      },
      getBtnDesc() {
        let str = ''
        if (this.isOver) {
          str = this.$t('luckyDraw.activity_end')
        } else {
          if (!this.isLogin) {
            str = this.$t('luckyDraw.login_tips')
          } else {
            str =
              this.$t('luckyDraw.participation_vouchers') +
              `: ${this.remainingShots}`
          }
        }
        return str
      },
      async getCouponInfos(couponIdString) {
        try {
          const res = await getCouponList({
            country: this.region,
            couponIdString,
          })
          return Promise.resolve(res)
        } catch (e) {
          window.console.log('getCouponInfos error ====> ', e)
          return Promise.reject()
        }
      },
      initLuckyDraw() {
        // 立即停止回到初始状态
        this.$refs.LuckDraw.init()
      },
      startCallBack() {
        this.$refs.LuckDraw.play()
      },
      endCallBack() {
        if (this.raffleResult.length < 1) {
          if (this.raffleError) {
            Toast(this.$t('common.noNetwork'))
          } else {
            // 未中奖
            Toast(this.$t('luckyDraw.award_desc.regret'))
          }
        } else {
          let kcoinsAmount = 0 // 记录 K 币累积金额
          for (let item of this.raffleResult) {
            const { awardType, awardContent, count } = item
            if (awardType * 1 === 3) {
              // 奖品为优惠券
              let str = ''
              const couponData =
                this.couponDetails[`${awardType}__${awardContent}`]
              const { couponType, couponPrice, couponDiscount } = couponData
              if (couponType * 1 === 1) {
                // 立减券
                const fommatedMoney = priceFormat(couponPrice, this.region, {
                  minimumFractionDigits: 0, // TODO: 格式化需要小数吗？
                })
                // 多语言翻译文案中可能有顺序颠倒的
                const reg = /{currency}\s*{amount}|{amount}\s*{currency}/g
                str = this.$t('luckyDraw.award_desc.award2').replace(
                  reg,
                  fommatedMoney
                )
              } else if (couponType * 1 === 2) {
                // 折扣券
                str = this.$t('luckyDraw.award_desc.award1').replaceAll(
                  '{percentage}',
                  100 - couponDiscount
                )
              }
              this.resultDesc += textFormat(str, count) + '\n'
            } else if (awardType * 1 === 5) {
              // 奖品为K币
              kcoinsAmount += awardContent * count * 1
            }
          }
          if (kcoinsAmount > 0) {
            const text =
              textFormat(this.$t('luckyDraw.award_desc.award3'), kcoinsAmount) +
              '\n'
            this.resultDesc += text
          }
          this.raffleResDesc = this.resultDesc
          this.showResult = !!this.resultDesc
        }
        // 重置描述语
        this.resultDesc = ''
        this.loading = false
      },
      closePopup() {
        this.showResult = false
      },
      btnClickHandler(data) {
        if (data.type === 'login') {
          this.handleClickLogin()
        } else if (data.type === 'buyShots') {
          this.handleClickToBuy()
        } else if (data.type === 'raffle') {
          this.handleRaffle(data)
        }
      },
      handleRaffle(data) {
        if (this.loading) {
          return
        }
        if (this.showResult) {
          // 若此时还未关闭中奖弹窗，则直接关闭
          this.closePopup()
        }
        this.raffleNum = data.count * 1
        if (data.count > this.remainingShots) {
          return
        }
        if (this.raffleNum === 1) {
          trackClickTryOne(this.page)
        } else if (this.raffleNum === 10) {
          trackClickTryTen(this.page)
        }
        this.getLuckyDrawResult()
      },
      handleClickLogin() {
        this.$emit('login', {
          type: 'activity',
          act_id: this.activityId,
        })
      },
      handleClickToBuy() {
        if (this.loading) {
          return
        }
        trackGainShots(this.page)
        if (this.inPopup) {
          this.$emit('handleClose')
          return
        }
        const { query } = this.$route
        this.$router_push({
          path: `/${this.game}`,
          query: {
            ...query,
            from: 'luckyDraw',
          },
        })
      },
      goCheckMyPrize() {
        trackViewPrize(this.page)
        const { query } = this.$route
        this.$router_push({
          path: `/prize-record`,
          query: {
            ...query,
            from: this.gameName || 'luckyDraw',
            activityId: this.activityId,
          },
        })
      },
      async getLuckyDrawResult() {
        this.raffleError = false
        try {
          this.loading = true
          this.startCallBack()
          const res = await queryLuckyDrawResult(
            {
              activityId: this.activityId,
              country: this.region,
              game: this.game,
              drawCount: this.raffleNum,
              timestamp: new Date().getTime(),
            },
            ''
          )
          if (res && res.length > 0) {
            const awardsList = res.filter(
              (item) => item.awardType * 1 !== -1 // 只留下非“thanks”的抽奖结果
            )
            this.raffleResult = awardsList
            let award = {}
            if (awardsList.length < 1) {
              // 返回的全是 thanks
              award = {
                awardType: -1,
                awardContent: 'thanks',
              }
            } else {
              if (this.raffleNum * 1 === 1) {
                award = awardsList[0]
              } else if (this.raffleNum * 1 === 10) {
                // 若有多个奖品则取最后一个
                award = awardsList[awardsList.length - 1]
              }
            }
            const { awardType, awardContent } = award
            const prizeKey = `${awardType}__${awardContent}`
            this.stopLuckyDraw(prizeKey)
            this.getRemainingShots() // 查询剩余抽奖次数
          } else {
            this.raffleError = true
            this.stopLuckyDraw(`-1__thanks`)
          }
        } catch (e) {
          this.raffleError = true
          this.stopLuckyDraw(`-1__thanks`)
          window.console.log('查询抽奖结果出错', e)
        }
      },
      stopLuckyDraw(prizeKey) {
        let temp = this.rafflePrizePosition.get(prizeKey) // 注意返回的是数组
        this.$refs.LuckDraw.stop(temp[(Math.random() * temp.length) >> 0]) // 随机取一个位置作为中奖结果
      },
      async getRemainingShots() {
        try {
          const res = await queryRemainingShots({
            activityId: this.activityId,
            country: this.region,
            game: this.game,
          })
          const { drawCount = 0, usedDrawCount = 0 } = res
          this.remainingShots = Number(drawCount) // 下单得到的抽奖次数 - 被用掉的抽奖次数
          const upperLimitCount = this.configData?.everyUserUpperLimit // 每个用户可以参加活动的最大次数
          this.upperLimitCount = upperLimitCount - usedDrawCount // 剩余可抽奖次数上限，usedDrawCount：已抽奖次数
        } catch (e) {
          window.console.log('查询用户抽奖资格出错...', e)
        }
      },
    },
  }
</script>

<style lang="scss">
  .lucky-draw-wrapper {
    .lucky-grid-wrapper {
      width: 987px;
      height: 996px;
      background-image: url('~@/assets/images/activities/luckydraw/lucky-draw-container.png');
      background-size: contain;
      display: flex;
      justify-content: center;
      align-items: center;

      .lucky-canvas {
        width: 800px;
        height: 800px;
      }
    }
    .entry-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 32px;
      & > p {
        margin-left: 80px;
        font-size: 33px;
        line-height: 60px;
        color: #fff;
        text-decoration: underline;
        text-align: center;
      }
    }
  }
</style>
